/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useMemo, useRef, useState, useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button, Tooltip, Container, Row, Col } from 'react-bootstrap';
import FormControl from '@material-ui/core/FormControl';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';

const EvenntLoggingForm = ({
  values,
  handleChangeDate,
  columnDefs,
  handleSearch,
  fieldLevelError,
  spinner,
  handleOnChangeEvent,
  handleOnReset,
  dateValidation,
  gridData,
  screenName,
}) => {
  const [fullScreen, setFullScreen] = useState(false);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(gridRef);
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFullScreenViewClick = () => {
    setFullScreen(!fullScreen);
  };

  const frameworkComponents = {
    nameRenderName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.userName;
      if (name && name.length > 15) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    timeRenderName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.eventTime;
      if (name && name.length <= 11) {
        return <div>{name}</div>;
      }
      return <div>{name.substring(11)}</div>;
    },
    screenRenderName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.portletName;
      if (name && name.length > 12) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    fieldRenderName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.keyType;
      if (name && name.length > 14) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    keyRenderName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.key;
      if (name && name.length > 12) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    userRenderName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.userId;
      if (name && name.length > 12) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  const getKeyType1Options = () => {
    switch (values.portletName) {
      case 'NDC':
        return 'NDC';
      case 'Claim':
      case 'Number Of Units':
        return 'Claim ID';
      case 'Provider':
      case 'Ineligible Provider':
        return 'Provider ID';
      default:
        return '';
    }
  };

  return (
    <>
      {!fullScreen && (
        <div className="custom-check">
          <Spinner load={spinner} />
          <div className="panel tBillPanel-space pb-0">
            <div className="panel mb-3">
              <form autoComplete="off">
                <fieldset className="custom-fieldset ">
                  <FormControl>
                    <Container>
                      <Row style={{ margin: '-10px' }}>
                        <Col
                          xs={12}
                          md={2}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        >
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <div className="mui-custom-form with-select input-md override-width-95">
                              <KeyboardDatePicker
                                data-test="start-date"
                                id="begindate-picker-dialog"
                                label="Begin Date"
                                format="MM/dd/yyyy"
                                className="mandate-fields"
                                value={values.dateRangeOptionStartDate}
                                key={values.dateRangeOptionStartDate}
                                onBlur={(date) => {
                                  dateValidation(date, 'onBlur', 'startDt');
                                }}
                                onChange={(e) => {
                                  handleChangeDate(
                                    e,
                                    'dateRangeOptionStartDate'
                                  );
                                }}
                                maxDate={new Date()}
                                placeholder="mm/dd/yyyy"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                helperText={fieldLevelError.startDate}
                                error={fieldLevelError.startDate}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                onKeyDown={async (e) => {
                                  if (e.keyCode == 67) {
                                    // copy date
                                    await window.navigator?.clipboard.writeText(e?.target?.value);
                                  }
                                }}
                              />
                            </div>
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col
                          xs={12}
                          md={2}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        >
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <div className="mui-custom-form with-select input-md override-width-95">
                              <KeyboardDatePicker
                                data-test="end-date"
                                id="endDate-picker-dialog"
                                label="End Date"
                                format="MM/dd/yyyy"
                                className="mandate-fields"
                                value={values.dateRangeOptionEndDate}
                                key={values.dateRangeOptionEndDate}
                                onChange={(date) => {
                                  handleChangeDate(
                                    date,
                                    'dateRangeOptionEndDate'
                                  );
                                }}
                                placeholder="mm/dd/yyyy"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                helperText={fieldLevelError.endDate}
                                error={fieldLevelError.endDate}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                onKeyDown={async (e) => {
                                  if (e.keyCode == 67) {
                                    // copy date
                                    await window.navigator?.clipboard.writeText(e?.target?.value);
                                  }
                                }}
                                onBlur={(date) => {
                                  dateValidation(date, 'onBlur', 'endDt');
                                }}
                              />
                            </div>
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        />
                        <Col
                          xs={12}
                          md={2}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        >
                          <div className="mui-custom-form">
                            <TextField
                              data-testid="beginTime"
                              id="beginTime"
                              label="Begin Time"
                              fullWidth
                              placeholder="HH:MM:SS AM/PM"
                              inputProps={{ maxLength: 11 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="beginTime"
                              value={values.beginTime || ''}
                              onChange={(e) => {
                                handleOnChangeEvent(e, 'beginTime');
                              }}
                            />
                          </div>
                        </Col>
                        <Col
                          xs={12}
                          md={2}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        >
                          <div className="mui-custom-form">
                            <TextField
                              data-testid="endTime"
                              id="endTime"
                              label="End Time"
                              fullWidth
                              placeholder="HH:MM:SS AM/PM"
                              inputProps={{ maxLength: 11 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="endTime"
                              value={values.endTime || ''}
                              onChange={(e) => {
                                handleOnChangeEvent(e, 'endTime');
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ margin: '-10px' }}>
                        <Col
                          xs={12}
                          md={2}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        >
                          <div className="mui-custom-form">
                            <TextField
                              required
                              data-testid="userID"
                              id="userID"
                              label="User ID"
                              fullWidth
                              placeholder=""
                              // inputProps={{ maxLength: 255 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="userID"
                              value={values.userID || ''}
                              onChange={(e) => {
                                handleOnChangeEvent(e, 'userID');
                              }}
                            />
                          </div>
                        </Col>
                        <Col
                          xs={12}
                          md={2}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        >
                          <div className="mui-custom-form">
                            <TextField
                              data-testid="portletName"
                              id="portletName"
                              label="Screen Name"
                              fullWidth
                              select
                              required
                              placeholder=""
                              name="portletName"
                              inputProps={{ maxLength: 11, id: 'portletName' }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={values.portletName}
                              onChange={(e) => {
                                handleOnChangeEvent(e, 'portletName');
                              }}
                            >
                              {/* <MenuItem selected></MenuItem> */}
                              {screenName &&
                                screenName.map((item) => {
                                  return (
                                    <MenuItem key={item.id} value={item.val}>
                                      {item.label}
                                    </MenuItem>
                                  );
                                })}
                            </TextField>
                          </div>
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        />
                        <Col
                          xs={12}
                          md={2}
                          style={{ padding: '10px 0', marginRight: '35px' }}
                        >
                          <div className="mui-custom-form">
                            <TextField
                              data-testid="keyType1"
                              id="keyType1"
                              label="Field Type/Name"
                              fullWidth
                              disabled
                              placeholder=""
                              name="keyType1"
                              inputProps={{ maxLength: 11, id: 'keyType1' }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={getKeyType1Options()}
                              // onChange={(e) =>
                              //   handleOnChangeEvent(e, 'keyType1')
                              // }
                            ></TextField>
                          </div>
                        </Col>
                      </Row>
                      <div className="float-right mt-2 hide-on-print">
                        <Button
                          onClick={handleSearch}
                          className="btn btn btn-success same-font-family"
                        >
                          <SVGComponent iconName="Icon-search" /> Search
                        </Button>
                        <Button
                          className="btn-success same-font-family"
                          onClick={() => handleOnReset()}
                        >
                          Reset
                        </Button>
                      </div>
                    </Container>
                  </FormControl>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      )}
      <div className="panel tBillPanel-space pb-0 frr-tbl-with-feature">
        <div style={containerStyle}>
          <Grid
            gridHeight={fullScreen ? '100vh' : 350}
            fullScreenView={fullScreen}
            handleFullScreenViewClick={handleFullScreenViewClick}
            rowData={
              getKeyType1Options() === 'Claim ID' && gridData?.length
                ? gridData.map((obj) => {
                    let data = obj;
                    data.claimId = obj.key?.split('-')?.[0];
                    data.claimLineNum = obj.key?.split('-')?.[1];
                    return data;
                  })
                : gridData
            }
            columnDefs={columnDefs}
            data-testid="onEditingStopped"
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            singleClickEdit={false}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            exportFile
            isScrollOn
            fileName="Event Logging"
            frameworkComponents={frameworkComponents}
          />
        </div>
      </div>
    </>
  );
};
export default EvenntLoggingForm;
